

















import {Component, Prop, Vue} from 'vue-property-decorator';
import AssignmentEntry from '@/pages/overall/overall-course/assignment-entry/assignment-entry.vue';
import {Assignment, AssignmentType} from '@/logic/course';

@Component({
    components: {AssignmentEntry}
})
export default class AssignmentTypeHead extends Vue
{
    @Prop({required: true}) type: AssignmentType;
    @Prop({required: true}) assignments: Assignment[];

    get filteredAssignments()
    {
        // Filter assignments to only this type
        return this.assignments.filter(a => a.typeId == this.type.id);
    }
}
